import { render } from "./AddPlacementWizard.vue?vue&type=template&id=60a817c1&scoped=true"
import script from "./AddPlacementWizard.vue?vue&type=script&lang=js"
export * from "./AddPlacementWizard.vue?vue&type=script&lang=js"

import "./AddPlacementWizard.vue?vue&type=style&index=0&id=60a817c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a817c1"]])

export default __exports__